// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-message {\n  top: 0px !important;\n}\n.ant-message-notice-content {\n  padding: 0px !important;\n  margin-top: 0.98958vw !important;\n  background: rgba(255,255,255,0) !important;\n  box-shadow: 0 0 0 #ccc;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
